export default {
    listagem: {
        titulo_pagina: 'Lista de Tipos',
        empty: 'Nenhum Valor Localizado para esse Tipo',
        novo: 'Criar novo Tipo',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Tipo encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar',
            valores: 'Valores'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Tipo',
            editar: 'Editar Tipo'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Tipo'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Tipo'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Tipo'
            },
            botao_salvar : 'Salvar Tipo'
        },
        create: {
            success: 'Tipo criado com Sucesso!',
            error: 'Error ao criar Tipo!'
        },
        update: {
            success: 'Tipo editado com Sucesso!',
            error: 'Error ao editar Tipo!'
        }
    },
    value: {
        form: {
            titulo_pagina: {
                criar: 'Criar novo Tipo',
                editar: 'Editar Tipo'
            },
            fields: {
                codigo: {
                    label: 'Código',
                    description: 'Código do Tipo'
                },
                nome: {
                    label: 'Nome',
                    description: 'Nome do Tipo'
                },
                description: {
                    label: 'Descrição',
                    description: 'Descrição e/ou Explicação do valor'
                },
                status: {
                    label: 'Status',
                    description: 'Status ativo ou inativo do Tipo'
                },
                botao_salvar : 'Salvar Tipo'
            },
            create: {
                success: 'Tipo criado com Sucesso!',
                error: 'Error ao criar Tipo!'
            },
            update: {
                success: 'Tipo editado com Sucesso!',
                error: 'Error ao editar Tipo!'
            }
        }
    }
}
